import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const VideoOffIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.1663 5.62299L13.9133 4.02045C14.0399 3.94665 14.1838 3.9077 14.3303 3.90717C14.4401 3.90679 14.5487 3.92826 14.6497 3.96967L14.7483 4.01849L14.8401 4.07904C14.8977 4.12318 14.9491 4.17485 14.9934 4.23236L15.0549 4.32318L15.1028 4.42181C15.1446 4.5227 15.1663 4.63124 15.1663 4.74115V11.2167C15.1662 11.4198 15.0438 11.6029 14.8557 11.6796C14.6677 11.7564 14.452 11.7114 14.3098 11.5663L6.74927 3.84369C6.60869 3.69997 6.56798 3.4861 6.64575 3.30072C6.72376 3.11519 6.90543 2.99408 7.10669 2.99408H9.33325C9.81948 2.99408 10.2863 3.18737 10.6301 3.53119C10.9737 3.8749 11.1662 4.3411 11.1663 4.82709V5.62299Z"
      fill="currentColor"
    />
    <path
      d="M4.00033 3.5L4.09798 3.50977C4.19409 3.52898 4.28351 3.57616 4.35384 3.64648L11.0199 10.3135C11.1136 10.4072 11.1663 10.5344 11.1663 10.667C11.1663 11.1531 10.973 11.6192 10.6292 11.9629C10.2854 12.3066 9.81949 12.5 9.33333 12.5H2.66634C2.18023 12.4999 1.71418 12.3066 1.37044 11.9629C1.0267 11.6192 0.83342 11.1531 0.833334 10.667V5.33301C0.83342 4.84689 1.0267 4.38085 1.37044 4.03711C1.71418 3.69337 2.18023 3.50009 2.66634 3.5H4.00033Z"
      fill="currentColor"
    />
    <path
      d="M0.979817 0.979821C1.17508 0.784558 1.49159 0.784558 1.68685 0.979821L15.0199 14.3128C15.2151 14.5081 15.2151 14.8246 15.0199 15.0199C14.8246 15.2151 14.5081 15.2151 14.3128 15.0199L0.979817 1.68685C0.784555 1.49159 0.784555 1.17508 0.979817 0.979821Z"
      fill="currentColor"
    />
  </svg>
);
